import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "versioncuesyncstatus"
    }}>{`VersionCueSyncStatus`}</h1>
    <p>{`The synchronization status of the file in Version Cue.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FILE_DOWNLOADED`}</strong>{` = 1986220868`}</p>
      <p parentName="blockquote">{`The project version of the file was downloaded to the local workspace.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FILE_UPLOADED`}</strong>{` = 1986220885`}</p>
      <p parentName="blockquote">{`The local version of the file was uploaded to the project.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FILE_UNLOCKED`}</strong>{` = 1986220876`}</p>
      <p parentName="blockquote">{`The file was unlocked locally.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FILE_SKIPPED`}</strong>{` = 1986220875`}</p>
      <p parentName="blockquote">{`The file was not synchronized.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FILE_NO_CHANGE`}</strong>{` = 1986220878`}</p>
      <p parentName="blockquote">{`The synchronization resulted in no change because the local and project versions were identical.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      